var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogowebzy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 138.89 43.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 214.27,
    y1: -50.38,
    x2: -93.98,
    y2: 56.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#12c2e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c471ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f64f59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 215.43,
    y1: -47.02,
    x2: -92.82,
    y2: 59.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 215.09,
    y1: -47.98,
    x2: -93.16,
    y2: 58.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 220.2,
    y1: -33.21,
    x2: -88.05,
    y2: 73.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 228.32,
    y1: -9.71,
    x2: -79.93,
    y2: 96.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 219.07,
    y1: -36.48,
    x2: -89.18,
    y2: 70.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 224.71,
    y1: -20.15,
    x2: -83.54,
    y2: 86.35,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34,3.74V24.83l-.55-1L27.23,13.05V3.82a3.5,3.5,0,0,1,.15-1A3.39,3.39,0,0,1,34,3.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34,30.89v.2a.22.22,0,0,1,0,.08v.11a3.39,3.39,0,0,1-3.39,3.08,3.41,3.41,0,0,1-3-1.85l-3-5.14L23,24.58l-2.59-4.49v8.37l-.56-1L13.64,16.69V7.17a.22.22,0,0,0,0-.08v0a0,0,0,0,1,0,0V7a.28.28,0,0,1,0-.09,2.84,2.84,0,0,1,.09-.42,3.4,3.4,0,0,1,6.3-.61h0L23,11l1.61,2.79,2.59,4.49,6.35,11A3.31,3.31,0,0,1,34,30.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20.44,34.55v.14a.08.08,0,0,0,0,0v.08s0,.08,0,.11A3.41,3.41,0,0,1,17,38a3.43,3.43,0,0,1-3-1.86L11,31,.46,12.7a3.36,3.36,0,0,1-.32-2.65,3.41,3.41,0,0,1,6.22-.76L11,17.38l2.6,4.5,6.36,11A3.49,3.49,0,0,1,20.44,34.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M89.22,16.61a13,13,0,0,0-2.68-4.1c-.15-.17-.31-.32-.47-.47a1.2,1.2,0,0,0-.21-.17,11.56,11.56,0,0,0-3.29-2.08,12.31,12.31,0,0,0-4.89-1A9.77,9.77,0,0,0,75.93,9a12.17,12.17,0,0,0-1.72.5,6.59,6.59,0,0,0-1.55.83,4.66,4.66,0,0,0-1.11,1,.86.86,0,0,0-.13.14V3.07A3.06,3.06,0,0,0,68.35,0h-.13a3.07,3.07,0,0,0-2.46,1.23,3.36,3.36,0,0,0-.42.77,1.4,1.4,0,0,0-.09.29,1.14,1.14,0,0,0-.06.25,3.07,3.07,0,0,0,0,.53V21.8a13.55,13.55,0,0,0,1,5.21,12.46,12.46,0,0,0,2,3.34c.22.26.44.51.68.75a12.16,12.16,0,0,0,4,2.68,12.49,12.49,0,0,0,4.88,1,12.64,12.64,0,0,0,4.89-.94,11.48,11.48,0,0,0,3.5-2.21l.16-.14c.11-.09.21-.19.31-.29a12.32,12.32,0,0,0,2-2.6c.06-.1.11-.2.16-.3a.08.08,0,0,1,0,0c.19-.37.38-.76.54-1.15l.15-.4a0,0,0,0,1,0,0,13.79,13.79,0,0,0,.83-4.85A13.55,13.55,0,0,0,89.22,16.61Zm-6.14,7.63,0,.08a6.54,6.54,0,0,1-.32.65l0,.05a2.55,2.55,0,0,1-.14.24,5.89,5.89,0,0,1-.79,1,4.37,4.37,0,0,1-.44.42h0a5.7,5.7,0,0,1-1.49.94,5.72,5.72,0,0,1-4.72,0,6,6,0,0,1-1.95-1.37,6.25,6.25,0,0,1-1.29-2.07,6.54,6.54,0,0,1-.48-2.57,6.62,6.62,0,0,1,.2-1.6,5.79,5.79,0,0,1,.27-.8,0,0,0,0,1,0,0L72,19a6.73,6.73,0,0,1,1.13-1.78h0a.21.21,0,0,1,.06-.08A6.21,6.21,0,0,1,75.1,15.7a5,5,0,0,1,2.36-.56,5.7,5.7,0,0,1,2.36.49,6.12,6.12,0,0,1,2,1.38,6.53,6.53,0,0,1,1.31,2.07,7.06,7.06,0,0,1,.47,2.59A6.91,6.91,0,0,1,83.08,24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M138.89,13V30.92a11.83,11.83,0,0,1-1,4.75,11.28,11.28,0,0,1-.55,1.1h0a12.24,12.24,0,0,1-2.13,2.77,12.8,12.8,0,0,1-4,2.63,12,12,0,0,1-4.79,1h0a3,3,0,0,1-3-3v-.19a2.88,2.88,0,0,1,.1-.78,3,3,0,0,1,3-2.26h.28a4.87,4.87,0,0,0,1.7-.3,5.88,5.88,0,0,0,1.52-.82,6,6,0,0,0,1.22-1.24c.11-.15.22-.3.31-.45h0a7.21,7.21,0,0,0,.56-1.11l-2,.86a5.23,5.23,0,0,1-2.06.44,10.73,10.73,0,0,1-4.12-.8,10.17,10.17,0,0,1-3.37-2.27,10.77,10.77,0,0,1-2.28-3.58,12.9,12.9,0,0,1-.83-4.73V12.37a3.23,3.23,0,0,1,.1-.76,3.05,3.05,0,0,1,.79-1.37,3,3,0,0,1,5.13,2.13v10.8a6,6,0,0,0,.37,2.21,4.56,4.56,0,0,0,1,1.58,3.9,3.9,0,0,0,1.46.94,5,5,0,0,0,1.79.31,3.85,3.85,0,0,0,1.67-.38,5,5,0,0,0,1.55-1.19,5.73,5.73,0,0,0,.47-.63,5.44,5.44,0,0,0,.51-1,5.07,5.07,0,0,0,.35-1.85V13a3.33,3.33,0,0,1,.1-.78,3.07,3.07,0,0,1,2.95-2.27h.18A3.06,3.06,0,0,1,138.89,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M60.1,25.89a3,3,0,0,0-4.23.11l-.47.48a6.64,6.64,0,0,1-5.89,1.59h0L49,28,59.86,17.12a3.47,3.47,0,0,0,.25-.29,2.53,2.53,0,0,0,.31-.49,3.1,3.1,0,0,0-.54-3.63l0,0a13.37,13.37,0,0,0-2.37-1.86A12.64,12.64,0,0,0,41.9,30.48a12.39,12.39,0,0,0,3.16,2.34,12.64,12.64,0,0,0,11.69,0,10.79,10.79,0,0,0,1.67-1,9.75,9.75,0,0,0,1.21-1s.63-.63.78-.8h0a4,4,0,0,0,.28-.43s0,0,0,0a3,3,0,0,0-.62-3.6ZM46.24,17A6.64,6.64,0,0,1,53,15.33l-1,1-7.35,7.35a6.37,6.37,0,0,1-.1-3.72,7.16,7.16,0,0,1,.23-.75A6.26,6.26,0,0,1,46.24,17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M113.26,30.72a3,3,0,0,1-3,3H96.13a3,3,0,0,1-3-3,3.08,3.08,0,0,1,.09-.75h0a3,3,0,0,1,.54-1.09l9.62-11.83.91-1.1H96.13a3,3,0,0,1-3-3,3.16,3.16,0,0,1,.09-.76,3,3,0,0,1,2.91-2.25h14.12a3,3,0,0,1,2.49,4.71l-.13.14L102,27.71h8.27A3,3,0,0,1,113.26,30.72Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogowebzy);
export default __webpack_public_path__ + "static/media/logo webzy.3200863066a4721ec0d919b75c46dcfb.svg";
export { ForwardRef as ReactComponent };